import { render } from "./boost-grid.vue?vue&type=template&id=1a71d090"
import script from "./boost-grid.vue?vue&type=script&lang=js"
export * from "./boost-grid.vue?vue&type=script&lang=js"

import "./boost-grid.vue?vue&type=style&index=0&id=1a71d090&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__